import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupCodeCopyButtons()
    this.setupWikilinks()
    this.setupMermaid()
  }

  setupCodeCopyButtons() {
    // Add global copy function
    window.copyCode = (button) => {
      const wrapper = button.closest('.code-block-wrapper')
      const code = wrapper.querySelector('code')
      const text = code.textContent
      
      navigator.clipboard.writeText(text).then(() => {
        const originalText = button.textContent
        button.textContent = 'Copied!'
        button.style.background = '#10b981'
        button.style.color = 'white'
        
        setTimeout(() => {
          button.textContent = originalText
          button.style.background = ''
          button.style.color = ''
        }, 2000)
      }).catch(err => {
        console.error('Failed to copy code: ', err)
        button.textContent = 'Copy failed'
        setTimeout(() => {
          button.textContent = 'Copy'
        }, 2000)
      })
    }
  }

  setupWikilinks() {
    const wikilinks = this.element.querySelectorAll('.wikilink')
    wikilinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const page = link.dataset.page
        console.log('Navigate to wikilink:', page)
        // Implement wikilink navigation logic here
        // For now, just show an alert
        alert(`Wikilink to "${page}" - navigation not yet implemented`)
      })
    })
  }

  setupMermaid() {
    if (typeof window.renderMermaid === 'function') {
      window.renderMermaid()
    } else {
      setTimeout(() => {
        if (typeof window.renderMermaid === 'function') {
          window.renderMermaid()
        }
      }, 250)
    }
  }
}
